module.exports = __webpack_public_path__ + "img/businessTimeAndPhonePic.df16af5b.png";